var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _circle, _g17, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _rect2, _rect3, _rect4, _g18, _g19, _path56, _rect5, _rect6, _rect7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonnationHistoryBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1064,
    height: 556,
    viewBox: "0 0 1064 556",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2100_37058)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1062.21,
    height: 556,
    transform: "translate(0.895508)",
    fill: "#FFD9CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M776.712 78.7147C782.329 86.1723 788.915 93.8235 797.922 95.7606C806.058 97.5039 814.581 94.3078 821.361 89.4653C839.957 76.1965 847.995 52.8551 863.007 35.7123C876.179 20.5066 894.775 10.1435 905.913 -6.70875C917.147 -23.7547 919.278 -46.0307 912.886 -65.498C906.493 -84.9653 892.256 -101.236 874.726 -111.696C855.743 -122.931 830.562 -127.096 812.16 -114.989C803.928 -109.566 797.826 -101.43 792.208 -93.2945C774.194 -67.3381 748.334 -31.5029 742.232 0.0708618C736.906 27.7705 759.763 56.0513 776.712 78.6179V78.7147Z",
    fill: "url(#paint0_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.712 78.7147C782.329 86.1723 788.915 93.8235 797.922 95.7606C806.058 97.5039 814.581 94.3078 821.361 89.4653C839.957 76.1965 847.995 52.8551 863.007 35.7123C876.179 20.5066 894.775 10.1435 905.913 -6.70875C917.147 -23.7547 919.278 -46.0307 912.886 -65.498C906.493 -84.9653 892.256 -101.236 874.726 -111.696C855.743 -122.931 830.562 -127.096 812.16 -114.989C803.928 -109.566 797.826 -101.43 792.208 -93.2945C774.194 -67.3381 748.334 -31.5029 742.232 0.0708618C736.906 27.7705 759.763 56.0513 776.712 78.6179V78.7147Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.759 317.839C916.571 319.001 922.672 319.873 928.387 318.323C934.488 316.677 939.524 312.512 944.367 308.445C966.643 289.752 989.016 271.06 1011.29 252.367C1018.36 246.459 1025.63 240.261 1029.89 232.125C1037.34 217.791 1034.25 200.358 1029.6 184.958C1022.04 159.777 1010.71 135.757 996.28 113.772C984.077 95.1763 965.772 76.4839 943.592 78.421C914.634 81.036 899.331 116.484 871.438 124.716C855.844 129.268 839.282 124.523 823.205 122.198C793.956 118.034 759.961 123.651 743.787 151.157C726.741 180.116 746.304 200.358 763.931 223.118C800.929 270.769 850.517 306.217 910.662 317.936L910.759 317.839Z",
    fill: "url(#paint1_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.759 317.839C916.571 319.001 922.672 319.873 928.387 318.323C934.488 316.677 939.524 312.512 944.367 308.445C966.643 289.752 989.016 271.06 1011.29 252.367C1018.36 246.459 1025.63 240.261 1029.89 232.125C1037.34 217.791 1034.25 200.358 1029.6 184.958C1022.04 159.777 1010.71 135.757 996.28 113.772C984.077 95.1763 965.772 76.4839 943.592 78.421C914.634 81.036 899.331 116.484 871.438 124.716C855.844 129.268 839.282 124.523 823.205 122.198C793.956 118.034 759.961 123.651 743.787 151.157C726.741 180.116 746.304 200.358 763.931 223.118C800.929 270.769 850.517 306.217 910.662 317.936L910.759 317.839Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M795.246 639.198C809.484 656.922 823.14 663.798 830.501 666.898C848.999 674.549 870.016 673.193 889.483 668.641C925.028 660.312 959.604 639.585 974.907 606.462C977.037 601.813 978.878 596.68 978.297 591.547C977.425 584.089 973.164 578.956 971.517 577.019C955.73 558.617 913.89 564.719 894.52 542.152C882.607 528.302 880.379 504.961 889.193 495.469C899.75 484.041 921.154 496.729 934.132 485.3C944.98 475.809 943.14 455.567 939.072 438.133C927.74 428.254 918.249 420.312 911.663 414.889C835.924 352.128 832.147 356.681 812.002 334.695C804.35 326.366 796.893 317.552 787.014 312.032C777.135 306.414 762.704 306.995 754.762 310.773C737.038 319.102 737.426 354.453 751.082 482.879C757.668 544.961 764.351 600.941 795.246 639.392V639.198Z",
    fill: "url(#paint2_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.246 639.198C809.484 656.922 823.14 663.798 830.501 666.898C848.999 674.549 870.016 673.193 889.483 668.641C925.028 660.312 959.604 639.585 974.907 606.462C977.037 601.813 978.878 596.68 978.297 591.547C977.425 584.089 973.164 578.956 971.517 577.019C955.73 558.617 913.89 564.719 894.52 542.152C882.607 528.302 880.379 504.961 889.193 495.469C899.75 484.041 921.154 496.729 934.132 485.3C944.98 475.809 943.14 455.567 939.072 438.133C927.74 428.254 918.249 420.312 911.663 414.889C835.924 352.128 832.147 356.681 812.002 334.695C804.35 326.366 796.893 317.552 787.014 312.032C777.135 306.414 762.704 306.995 754.762 310.773C737.038 319.102 737.426 354.453 751.082 482.879C757.668 544.961 764.351 600.941 795.246 639.392V639.198Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.11 660.895C620.396 670.193 614.101 679.781 604.512 685.011C590.566 692.662 573.422 689.563 557.539 691.113C541.655 692.662 523.447 703.897 525.965 719.684C527.806 731.016 539.621 737.795 550.566 740.991C561.51 744.188 573.713 745.931 582.236 753.679C589.016 759.781 592.405 768.982 599.282 775.083C604.318 779.538 610.808 781.96 617.2 783.703C674.246 798.812 731.098 764.72 787.369 747.093C803.737 741.96 820.976 737.989 834.439 727.335C847.901 716.682 856.037 696.924 847.514 682.105C840.153 669.418 824.269 665.253 810.516 660.314C764.414 643.655 727.03 604.43 712.793 557.457C701.267 519.588 675.311 564.43 666.788 580.605C652.744 607.239 641.897 635.035 626.11 660.895Z",
    fill: "url(#paint3_linear_2100_37058)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.11 660.895C620.396 670.193 614.101 679.781 604.512 685.011C590.566 692.662 573.422 689.563 557.539 691.113C541.655 692.662 523.447 703.897 525.965 719.684C527.806 731.016 539.621 737.795 550.566 740.991C561.51 744.188 573.713 745.931 582.236 753.679C589.016 759.781 592.405 768.982 599.282 775.083C604.318 779.538 610.808 781.96 617.2 783.703C674.246 798.812 731.098 764.72 787.369 747.093C803.737 741.96 820.976 737.989 834.439 727.335C847.901 716.682 856.037 696.924 847.514 682.105C840.153 669.418 824.269 665.253 810.516 660.314C764.414 643.655 727.03 604.43 712.793 557.457C701.267 519.588 675.311 564.43 666.788 580.605C652.744 607.239 641.897 635.035 626.11 660.895Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.481 629.414C345.82 661.569 330.808 656.823 312.019 683.748C297.491 704.668 291.777 735.177 308.242 754.644C320.348 768.881 340.493 772.949 359.089 773.627C386.014 774.595 405.384 778.469 414.489 778.663C490.614 780.406 532.745 814.208 542.139 800.649C549.5 789.995 529.065 762.005 519.864 751.157C508.726 738.179 502.914 737.211 495.166 728.881C473.762 705.83 485.481 677.162 480.348 637.356C473.181 581.86 436.377 530.528 416.038 533.531C408.483 534.596 402.091 547.574 389.404 573.337C372.648 607.429 375.845 612.272 365.384 629.414H365.481Z",
    fill: "url(#paint4_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.481 629.414C345.82 661.569 330.808 656.823 312.019 683.748C297.491 704.668 291.777 735.177 308.242 754.644C320.348 768.881 340.493 772.949 359.089 773.627C386.014 774.595 405.384 778.469 414.489 778.663C490.614 780.406 532.745 814.208 542.139 800.649C549.5 789.995 529.065 762.005 519.864 751.157C508.726 738.179 502.914 737.211 495.166 728.881C473.762 705.83 485.481 677.162 480.348 637.356C473.181 581.86 436.377 530.528 416.038 533.531C408.483 534.596 402.091 547.574 389.404 573.337C372.648 607.429 375.845 612.272 365.384 629.414H365.481Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.627 227.539C307.189 234.202 325.206 221.187 331.228 205.299C345.211 167.737 314.572 124.078 307.582 82.5137C297.431 21.8618 339.445 -30.2896 390.456 -61.635C441.466 -92.9805 502.688 -110.174 553.96 -141.367C563.757 -147.42 573.746 -154.413 576.974 -165.159C582.722 -183.907 564.617 -206.219 543.559 -214.624C522.502 -223.029 499.917 -221.207 478.578 -218.815C445.654 -215.157 412.733 -210.596 380.341 -205.129C349.519 -199.957 317.72 -193.397 295.076 -174.796C269.692 -153.875 259.358 -120.511 236.144 -97.5865C221.407 -82.9774 201.673 -73.0548 187.264 -58.1057C111.703 20.3117 172.011 185.729 288.692 227.426L288.627 227.539Z",
    fill: "url(#paint5_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.627 227.539C307.189 234.202 325.206 221.187 331.228 205.299C345.211 167.737 314.572 124.078 307.582 82.5137C297.431 21.8618 339.445 -30.2896 390.456 -61.635C441.466 -92.9805 502.688 -110.174 553.96 -141.367C563.757 -147.42 573.746 -154.413 576.974 -165.159C582.722 -183.907 564.617 -206.219 543.559 -214.624C522.502 -223.029 499.917 -221.207 478.578 -218.815C445.654 -215.157 412.733 -210.596 380.341 -205.129C349.519 -199.957 317.72 -193.397 295.076 -174.796C269.692 -153.875 259.358 -120.511 236.144 -97.5865C221.407 -82.9774 201.673 -73.0548 187.264 -58.1057C111.703 20.3117 172.011 185.729 288.692 227.426L288.627 227.539Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21855 261.107C11.0554 295.633 23.3774 330.548 48.8001 354.56C52.1725 357.805 56.0634 360.92 60.6031 362.088C79.1513 366.89 89.3988 339.244 107.428 332.624C133.24 323.149 166.056 359.103 185.641 339.763C192.646 332.884 193.294 321.851 192.127 312.246C187.328 269.803 158.921 234.369 133.499 200.103C108.076 165.837 83.3026 126.12 87.972 83.5468C90.5662 60.0538 101.85 38.378 107.168 15.2744C112.487 -7.82917 109.762 -35.865 90.5655 -49.6233C85.3772 -53.3874 78.7628 -55.8535 72.5368 -54.2959C46.4656 -47.8062 53.3395 -7.18016 50.8751 11.2508C47.2433 38.378 35.5696 57.3281 24.9336 83.417C2.36445 139.359 -4.76947 201.531 5.47743 260.977L5.21855 261.107Z",
    fill: "url(#paint6_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21855 261.107C11.0554 295.633 23.3774 330.548 48.8001 354.56C52.1725 357.805 56.0634 360.92 60.6031 362.088C79.1513 366.89 89.3988 339.244 107.428 332.624C133.24 323.149 166.056 359.103 185.641 339.763C192.646 332.884 193.294 321.851 192.127 312.246C187.328 269.803 158.921 234.369 133.499 200.103C108.076 165.837 83.3026 126.12 87.972 83.5468C90.5662 60.0538 101.85 38.378 107.168 15.2744C112.487 -7.82917 109.762 -35.865 90.5655 -49.6233C85.3772 -53.3874 78.7628 -55.8535 72.5368 -54.2959C46.4656 -47.8062 53.3395 -7.18016 50.8751 11.2508C47.2433 38.378 35.5696 57.3281 24.9336 83.417C2.36445 139.359 -4.76947 201.531 5.47743 260.977L5.21855 261.107Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4511 511.791C66.472 511.77 66.5077 511.78 66.5139 511.809C71.464 534.741 84.3415 558.045 106.306 566.173C114.344 569.175 123.255 569.95 130.616 574.309C140.01 579.926 145.24 590.386 149.986 600.168C160.252 621.476 170.422 642.88 180.688 664.188C185.24 673.776 190.179 683.655 198.605 690.047C207.031 696.439 220.3 697.795 227.758 690.241C233.569 684.236 234.15 674.841 232.6 666.609C228.436 644.527 213.036 626.609 199.961 608.207C186.886 589.805 175.458 567.529 180.978 545.737C188.242 516.875 223.206 497.989 222.334 468.256C221.947 456.73 216.039 446.174 209.55 436.585C190.179 407.626 142.528 361.331 105.337 384.575C68.167 407.807 58.2784 473.7 66.3885 511.773C66.3947 511.802 66.4302 511.812 66.4511 511.791Z",
    fill: "url(#paint7_linear_2100_37058)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4511 511.791C66.472 511.77 66.5077 511.78 66.5139 511.809C71.464 534.741 84.3415 558.045 106.306 566.173C114.344 569.175 123.255 569.95 130.616 574.309C140.01 579.926 145.24 590.386 149.986 600.168C160.252 621.476 170.422 642.88 180.688 664.188C185.24 673.776 190.179 683.655 198.605 690.047C207.031 696.439 220.3 697.795 227.758 690.241C233.569 684.236 234.15 674.841 232.6 666.609C228.436 644.527 213.036 626.609 199.961 608.207C186.886 589.805 175.458 567.529 180.978 545.737C188.242 516.875 223.206 497.989 222.334 468.256C221.947 456.73 216.039 446.174 209.55 436.585C190.179 407.626 142.528 361.331 105.337 384.575C68.167 407.807 58.2784 473.7 66.3885 511.773C66.3947 511.802 66.4302 511.812 66.4511 511.791Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1032.76 342.745C1032.76 342.793 1032.74 342.839 1032.71 342.879C1020.49 360.413 1003.01 376.337 1001.1 397.707C999.181 417.626 1011.55 435.627 1019.65 453.924C1027.75 472.22 1030.11 497.303 1013.91 508.96C1003.75 516.19 989.904 515.452 978.712 520.911C960.893 529.617 953.972 553.962 961.63 572.258C969.287 590.555 988.578 602.359 1008.31 604.572C1019.8 605.9 1032.17 603.982 1041 596.457C1055.29 584.063 1054.7 562.078 1061.91 544.519C1074.58 513.681 1111.54 497.746 1123.17 466.465C1133.93 437.988 1120.38 405.97 1125.24 375.87C1129.51 349.311 1147.77 324.965 1144.97 298.258C1141.58 265.65 1099.61 238.796 1070.46 259.6C1048.09 275.669 1048.37 320.164 1032.8 342.611C1032.77 342.65 1032.76 342.697 1032.76 342.745Z",
    fill: "url(#paint8_linear_2100_37058)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.76 342.745C1032.76 342.793 1032.74 342.839 1032.71 342.879C1020.49 360.413 1003.01 376.337 1001.1 397.707C999.181 417.626 1011.55 435.627 1019.65 453.924C1027.75 472.22 1030.11 497.303 1013.91 508.96C1003.75 516.19 989.904 515.452 978.712 520.911C960.893 529.617 953.972 553.962 961.63 572.258C969.287 590.555 988.578 602.359 1008.31 604.572C1019.8 605.9 1032.17 603.982 1041 596.457C1055.29 584.063 1054.7 562.078 1061.91 544.519C1074.58 513.681 1111.54 497.746 1123.17 466.465C1133.93 437.988 1120.38 405.97 1125.24 375.87C1129.51 349.311 1147.77 324.965 1144.97 298.258C1141.58 265.65 1099.61 238.796 1070.46 259.6C1048.09 275.669 1048.37 320.164 1032.8 342.611C1032.77 342.65 1032.76 342.697 1032.76 342.745Z",
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 437.967,
    cy: 212.493,
    r: 19.1386,
    fill: "url(#paint9_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437.967,
    cy: 212.493,
    r: 19.1386,
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.408 120.686C498.391 116.151 474.419 122.75 458.235 137.97C455.68 140.381 440.612 154.941 440.032 175.116C439.882 180.128 440.506 189.479 444.048 190.369C447.757 191.291 451.98 187.672 453.443 182.336C456.629 170.711 465.011 168.439 467.364 162.954C472.156 151.764 470.174 144.783 475.92 141.623C478.695 140.087 480.075 141.215 483.932 140.358C494.869 137.909 503.831 124.32 501.418 120.699L501.408 120.686Z",
    fill: "url(#paint10_linear_2100_37058)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.408 120.686C498.391 116.151 474.419 122.75 458.235 137.97C455.68 140.381 440.612 154.941 440.032 175.116C439.882 180.128 440.506 189.479 444.048 190.369C447.757 191.291 451.98 187.672 453.443 182.336C456.629 170.711 465.011 168.439 467.364 162.954C472.156 151.764 470.174 144.783 475.92 141.623C478.695 140.087 480.075 141.215 483.932 140.358C494.869 137.909 503.831 124.32 501.418 120.699L501.408 120.686Z",
    stroke: "white",
    strokeWidth: 1.01853
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.051,
    y: 239.512,
    width: 150.54,
    height: 52.8444,
    rx: 26.4222,
    fill: "url(#paint11_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.051,
    y: 239.512,
    width: 150.54,
    height: 52.8444,
    rx: 26.4222,
    stroke: "white",
    strokeWidth: 1.6597
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M484.686 343.239C484.686 343.188 484.687 343.137 484.687 343.086C484.687 316.35 463.013 294.676 436.277 294.676C409.541 294.676 387.868 316.35 387.868 343.086C387.868 343.137 387.868 343.188 387.868 343.239H387.868V555.03H433.856V391.436C434.658 391.475 435.465 391.495 436.277 391.495C437.089 391.495 437.896 391.475 438.698 391.436V555.03H484.687V343.239H484.686Z",
    fill: "url(#paint12_linear_2100_37058)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.686 343.239L483.856 343.237L483.854 344.069H484.686V343.239ZM387.868 343.239V344.069H388.7L388.698 343.237L387.868 343.239ZM387.868 343.239V342.41H387.038V343.239H387.868ZM387.868 555.03H387.038V555.86H387.868V555.03ZM433.856 555.03V555.86H434.686V555.03H433.856ZM433.856 391.436L433.897 390.607L433.027 390.564V391.436H433.856ZM438.698 391.436H439.528V390.564L438.657 390.607L438.698 391.436ZM438.698 555.03H437.868V555.86H438.698V555.03ZM484.687 555.03V555.86H485.517V555.03H484.687ZM484.687 343.239H485.517V342.41H484.687V343.239ZM483.857 343.086C483.857 343.136 483.857 343.186 483.856 343.237L485.516 343.242C485.516 343.19 485.516 343.138 485.516 343.086H483.857ZM436.277 295.506C462.555 295.506 483.857 316.808 483.857 343.086H485.516C485.516 315.892 463.471 293.846 436.277 293.846V295.506ZM388.698 343.086C388.698 316.808 410 295.506 436.277 295.506V293.846C409.083 293.846 387.038 315.892 387.038 343.086H388.698ZM388.698 343.237C388.698 343.186 388.698 343.136 388.698 343.086H387.038C387.038 343.138 387.038 343.19 387.038 343.242L388.698 343.237ZM387.868 342.41H387.868V344.069H387.868V342.41ZM387.038 343.239V555.03H388.698V343.239H387.038ZM387.868 555.86H433.856V554.2H387.868V555.86ZM434.686 555.03V391.436H433.027V555.03H434.686ZM436.277 390.665C435.479 390.665 434.686 390.646 433.897 390.607L433.816 392.264C434.631 392.305 435.452 392.325 436.277 392.325V390.665ZM438.657 390.607C437.869 390.646 437.075 390.665 436.277 390.665V392.325C437.103 392.325 437.923 392.305 438.739 392.264L438.657 390.607ZM437.868 391.436V555.03H439.528V391.436H437.868ZM438.698 555.86H484.687V554.2H438.698V555.86ZM485.517 555.03V343.239H483.857V555.03H485.517ZM484.687 342.41H484.686V344.069H484.687V342.41Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.606 278H577.642L598.953 209.952H646.562L665.606 278Z",
    fill: "url(#paint13_linear_2100_37058)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.606 278H577.642L598.953 209.952H646.562L665.606 278Z",
    stroke: "white",
    strokeWidth: 1.98606
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 646.52,
    cy: 165.14,
    r: 10.7881,
    fill: "url(#paint14_linear_2100_37058)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 646.52,
    cy: 165.14,
    r: 10.7881,
    stroke: "white",
    strokeWidth: 0.993029
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 624.943,
    cy: 185.057,
    r: 19.9164,
    fill: "url(#paint15_linear_2100_37058)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624.943,
    cy: 185.057,
    r: 19.9164,
    stroke: "white",
    strokeWidth: 1.98606
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2100_37058",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 605,
    y: 165,
    width: 40,
    height: 41
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 624.963,
    cy: 185.258,
    r: 19.8935,
    fill: "#D9D9D9"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2100_37058)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M631.538 175.728C628.765 177.194 625.605 178.024 622.251 178.024C611.264 178.024 602.357 169.118 602.357 158.131C602.357 147.144 611.264 138.237 622.251 138.237C632.173 138.237 640.398 145.501 641.9 155.001C644.672 153.535 647.832 152.705 651.186 152.705C662.173 152.705 671.08 161.612 671.08 172.599C671.08 183.585 662.173 192.492 651.186 192.492C641.264 192.492 633.039 185.228 631.538 175.728Z",
    fill: "url(#paint16_linear_2100_37058)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.538 175.728L632.028 175.651L631.92 174.965L631.305 175.289L631.538 175.728ZM641.9 155.001L641.409 155.079L641.518 155.765L642.132 155.44L641.9 155.001ZM631.305 175.289C628.603 176.718 625.522 177.528 622.251 177.528V178.521C625.688 178.521 628.928 177.67 631.77 176.167L631.305 175.289ZM622.251 177.528C611.538 177.528 602.854 168.844 602.854 158.131H601.861C601.861 169.392 610.99 178.521 622.251 178.521V177.528ZM602.854 158.131C602.854 147.418 611.538 138.734 622.251 138.734V137.741C610.99 137.741 601.861 146.87 601.861 158.131H602.854ZM622.251 138.734C631.925 138.734 639.945 145.816 641.409 155.079L642.39 154.924C640.851 145.186 632.421 137.741 622.251 137.741V138.734ZM642.132 155.44C644.834 154.011 647.915 153.202 651.186 153.202V152.209C647.749 152.209 644.509 153.059 641.667 154.562L642.132 155.44ZM651.186 153.202C661.899 153.202 670.583 161.886 670.583 172.599H671.576C671.576 161.337 662.447 152.209 651.186 152.209V153.202ZM670.583 172.599C670.583 183.311 661.899 191.995 651.186 191.995V192.989C662.447 192.989 671.576 183.86 671.576 172.599H670.583ZM651.186 191.995C641.512 191.995 633.492 184.913 632.028 175.651L631.047 175.806C632.586 185.543 641.016 192.989 651.186 192.989V191.995Z",
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M572.777 223.557L573.45 226.251L574.461 230.293L578.502 238.376L569.746 251.847L563.347 244.775L568.062 227.935V224.567L569.072 222.883H571.43L572.777 223.557Z",
    fill: "#F8F4EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M567.595 227.663C567.512 226.576 567.545 224.253 568.347 223.651C569.35 222.899 572.61 220.391 573.864 226.911C574.867 232.126 577.458 236.774 578.628 238.445",
    stroke: "#BA8227",
    strokeWidth: 0.739325
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M563.081 244.464C565.003 246.888 568.999 251.785 569.6 251.986",
    stroke: "#BA8227",
    strokeWidth: 0.739325
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M564.631 191.556C566.329 187.734 568.495 185.433 571.524 182.9L564.631 191.556Z",
    fill: "#DBF0DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M564.631 191.556C566.329 187.734 568.495 185.433 571.524 182.9",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M568.649 185.58C569.112 185.598 569.74 185.651 570.471 185.798C572.174 186.143 573.362 186.79 574.064 187.18C575.922 188.211 577.274 189.491 578.197 190.553",
    fill: "#DBF0DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M568.649 185.58C569.112 185.598 569.74 185.651 570.471 185.798C572.174 186.143 573.362 186.79 574.064 187.18C575.922 188.211 577.274 189.491 578.197 190.553",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M570.396 183.806C571.607 183.709 573.424 183.715 575.513 184.304C576.965 184.713 578.128 185.286 578.983 185.795",
    fill: "#DBF0DB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M570.396 183.806C571.607 183.709 573.424 183.715 575.513 184.304C576.965 184.713 578.128 185.286 578.983 185.795",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M572.195 188.986C574.206 190.288 577.619 191.458 578.196 190.553C578.664 189.819 577.13 187.935 575.993 187C575.314 186.441 574.726 186.105 573.477 185.604C572.862 185.357 572.228 185.125 571.567 185.095C570.426 185.042 569.673 185.451 570.169 186.572C570.797 187.989 572.036 188.882 572.196 188.986L572.195 188.986Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M575.459 178.894C575.685 178.898 576.359 178.911 576.478 179.234C576.839 180.206 571.969 183.396 571.463 182.855C571.048 182.409 573.051 178.846 575.458 178.894L575.459 178.894Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M579.756 185.912C579.989 185.256 577.833 183.555 575.584 183.284C574.365 183.137 572.744 183.366 572.667 183.841C572.636 184.025 572.842 184.22 573.142 184.427C574.961 185.676 579.446 186.783 579.754 185.912L579.756 185.912Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M571.544 182.905C571.826 182.532 572.19 182.106 572.653 181.675C573.131 181.229 573.596 180.888 573.998 180.628",
    fill: "#DBF0DB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M571.544 182.905C571.826 182.532 572.19 182.106 572.653 181.675C573.131 181.229 573.596 180.888 573.998 180.628",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M570.572 167.961C570.499 167.79 569.378 165.13 570.337 164.379C570.377 164.347 570.673 164.122 570.988 164.206C572.254 164.54 572.36 169.472 571.696 169.632C571.329 169.719 570.737 168.343 570.572 167.963L570.572 167.961Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M563.89 173.861C562.316 172.503 560.501 171.477 560.09 171.926C559.633 172.426 561.025 174.65 562.668 175.947C563.969 176.972 566.115 178.148 566.486 177.7C566.556 177.616 566.394 177.119 566.267 176.768",
    fill: "#DBF0DB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M563.89 173.861C562.316 172.503 560.501 171.477 560.09 171.926C559.633 172.426 561.025 174.65 562.668 175.947C563.969 176.972 566.115 178.148 566.486 177.7C566.556 177.616 566.394 177.119 566.267 176.768",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M565.906 234.78C564.323 223.139 562.873 211.391 563.674 199.671C564.475 187.95 567.67 176.138 574.61 166.659",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M566.897 182.002C566.755 179.019 566.193 174.971 565.153 170.875",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M571.861 170.868C571.807 169.917 571.693 168.847 571.48 167.686C571.256 166.463 570.964 165.373 570.66 164.428",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M569.892 174.497C571.84 173.006 573.969 171.753 576.217 170.774",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M563.85 169.625C563.976 169.267 564.169 168.888 564.523 168.754C564.887 168.617 565.296 168.788 565.604 169.026C566.262 169.532 566.65 170.317 566.885 171.113C567.158 172.039 567.244 173.016 567.155 173.976C567.101 174.561 566.9 176.507 566.266 176.769C565.633 177.03 564.706 175.49 564.456 175.07C564.005 174.314 563.705 173.465 563.579 172.593C563.435 171.601 563.514 170.573 563.851 169.626L563.85 169.625Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M576.15 169.163C577.317 168.563 578.902 168.616 579.785 169.586C579.881 169.691 579.971 169.815 579.976 169.958C579.981 170.11 579.889 170.247 579.792 170.362C579.255 170.996 578.459 171.341 577.677 171.621C577.014 171.859 576.333 172.064 575.635 172.165C575.282 172.216 573.731 172.428 573.566 172.013C573.442 171.702 574.413 170.648 574.612 170.417C575.047 169.913 575.555 169.469 576.15 169.163Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M560.135 171.923C560.826 172.975 561.537 174.049 562.541 174.81C563.677 175.671 565.544 176.873 566.265 176.905",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M557.082 201.117C557.522 199.795 558.327 198.457 559.646 198.009C559.839 197.943 560.052 197.899 560.242 197.972C560.431 198.044 560.558 198.217 560.668 198.386C561.865 200.244 562.002 202.602 561.723 204.794C561.509 206.486 561.066 208.149 560.418 209.726C560.087 210.53 559.729 211.52 559.186 212.205C558.433 213.155 558.323 212.682 557.898 211.643C556.553 208.362 555.943 204.546 557.082 201.116L557.082 201.117Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M549.635 205.157C547.921 203.129 546.668 200.575 546.757 197.922C546.786 197.093 546.954 196.247 547.411 195.555C547.868 194.862 548.652 194.351 549.481 194.38C550.571 194.419 551.424 195.331 552.002 196.257C553.104 198.025 553.682 200.06 554.249 202.065C554.544 203.112 556.349 208.513 555.106 209.201C553.863 209.888 550.316 205.963 549.635 205.158L549.635 205.157Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M556.347 220.798C555.417 219.992 554.619 218.972 554.339 217.773C554.22 217.263 554.199 216.717 554.371 216.222C554.544 215.727 554.926 215.289 555.429 215.137C555.975 214.969 556.573 215.154 557.066 215.442C557.873 215.915 558.492 216.647 559.055 217.392C560.129 218.814 561.066 220.341 561.847 221.944C562.012 222.282 562.121 222.787 561.783 222.956C561.664 223.016 561.523 223.006 561.39 222.994C559.499 222.837 557.786 222.043 556.349 220.798L556.347 220.798Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M565.269 230.231C562.965 220.759 556.546 212.88 552.56 203.984L565.269 230.231Z",
    fill: "#DBF0DB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M565.269 230.231C562.965 220.759 556.546 212.88 552.56 203.984",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M558.647 215.023C558.58 212.329 558.594 209.634 558.694 206.942L558.647 215.023Z",
    fill: "#DBF0DB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M558.647 215.023C558.58 212.329 558.594 209.634 558.694 206.942",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M562.822 223.455C561.135 222.01 559.343 220.686 557.468 219.498L562.822 223.455Z",
    fill: "#DBF0DB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M562.822 223.455C561.135 222.01 559.343 220.686 557.468 219.498",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M571.153 198.745C571.948 197.561 572.984 196.448 574.345 196.021C574.866 195.858 575.461 195.81 575.934 196.081C576.428 196.365 576.691 196.95 576.718 197.518C576.744 198.087 576.568 198.646 576.359 199.174C575.703 200.841 574.712 202.349 573.566 203.718C572.578 204.897 571.058 206.968 569.648 207.627C567.92 208.435 568.796 204.673 569.026 203.671C569.43 201.918 570.149 200.237 571.153 198.745Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M566.267 200.334C566.061 198.824 566.162 197.235 566.82 195.861C567.119 195.237 567.55 194.648 568.163 194.325C568.775 194.003 569.593 194.008 570.108 194.469C570.739 195.034 570.721 196.016 570.58 196.851C570.174 199.249 569.141 202.733 567.533 204.592C566.732 203.593 566.439 201.607 566.266 200.335L566.267 200.334Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M569.217 214.959C569.515 214.585 569.926 214.228 570.403 214.255C570.987 214.289 571.385 214.887 571.49 215.463C571.652 216.342 571.351 217.256 570.859 218.003C570.367 218.75 569.695 219.357 569.03 219.956C567.416 221.409 567.598 219.713 567.843 218.353C568.061 217.14 568.44 215.936 569.218 214.96L569.217 214.959Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M566.751 234.118C566.635 227.941 566.685 221.435 566.957 214.628C567.188 208.876 567.561 203.354 568.038 198.078",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M566.921 213.226C568.593 208.011 570.98 203.025 573.993 198.452",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M566.7 223.117C567.49 220.94 568.458 218.828 569.592 216.809",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M554.94 169.06C555.274 168.781 556.428 167.848 556.874 168.166C557.812 168.835 554.088 173.929 553.484 174.527C553.316 174.693 553.225 174.675 553.201 174.667C552.949 174.593 553.002 173.752 553.008 173.54C553.023 172.969 553.1 172.398 553.249 171.847C553.422 171.203 553.809 170 554.94 169.06Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M551.008 165.402C551.516 164.483 552.648 163.677 553.144 163.948C553.474 164.127 553.455 164.745 553.434 165.259C553.341 167.534 551.959 169.873 551.262 169.702C551.212 169.69 551.086 169.649 550.893 169.218C550.769 168.939 550.044 167.145 551.008 165.402Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M556.035 181.647C556.1 181.698 556.171 181.748 556.252 181.759C556.382 181.774 556.504 181.679 556.562 181.561C556.619 181.443 556.622 181.309 556.619 181.177C556.597 180.158 556.234 179.149 555.603 178.348C555.412 178.105 554.918 177.509 554.651 177.791C554.424 178.031 554.576 178.939 554.625 179.231C554.785 180.169 555.284 181.057 556.035 181.647Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M549.792 180.992C549.043 180.094 548.935 179.6 548.935 179.239C548.934 179.164 548.945 178.188 549.476 177.917C550.527 177.38 553.019 179.968 554.42 182.247C554.693 182.69 555.815 184.514 555.427 184.86C555.173 185.087 554.091 184.346 551.926 182.863C551.348 182.468 550.566 181.921 549.792 180.992Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M549.739 170.774C549.45 170.8 549.176 170.914 548.925 171.06C548.319 171.411 547.829 171.958 547.543 172.598C547.488 172.722 547.441 172.872 547.513 172.988C547.613 173.15 547.855 173.12 548.036 173.06C548.716 172.832 549.339 172.447 549.853 171.948C550.026 171.779 550.49 171.386 550.515 171.134C550.55 170.795 549.992 170.752 549.739 170.775L549.739 170.774Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M549.633 172.917C549.432 173.736 549.378 174.961 549.706 175.061C550.075 175.174 551.107 173.916 551.035 172.569C551.001 171.924 550.721 171.426 550.515 171.134C550.231 171.494 549.835 172.094 549.633 172.917Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M550.54 177.444C550.844 177.561 552.131 175.34 551.87 175.117C551.747 175.012 551.275 175.353 551.014 175.634C550.375 176.323 550.35 177.371 550.54 177.444Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M558.218 183.917C558.732 183.389 559.678 182.867 560.004 183.149C560.681 183.739 558.654 187.819 557.906 187.637C557.389 187.511 556.947 185.222 558.218 183.917Z",
    fill: "#DBF0DB",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M568.011 233.516C565.084 211.013 558.873 188.941 549.636 168.214",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M556.642 185.818C555.288 184.799 553.758 183.484 552.228 181.812C551.182 180.669 550.311 179.551 549.588 178.517",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M550.938 171.19C550.713 171.095 550.509 171.056 550.335 171.045C548.911 170.954 547.895 172.65 547.809 172.798",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M553.233 176.733C553.525 176.83 553.954 177.014 554.374 177.368C555.017 177.913 555.273 178.556 555.633 179.494C555.841 180.034 556.089 180.801 556.253 181.759",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M558.221 190.462C558.03 189.813 557.826 188.83 557.907 187.637C558.026 185.854 558.713 184.542 559.124 183.882",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M552.344 174.542C551.967 174.878 551.479 175.396 551.077 176.132C550.875 176.504 550.735 176.857 550.638 177.163",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M552.334 174.524C551.99 173.133 551.659 171.73 551.587 170.299C551.516 168.868 551.717 167.396 552.388 166.131",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M553.04 176.249C553.028 175.558 553.091 174.669 553.374 173.681C554.025 171.412 555.444 169.989 556.173 169.353",
    stroke: "#248B5A",
    strokeWidth: 0.192668,
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 561.695,
    y: 228.033,
    width: 11.798,
    height: 4.77711,
    rx: 2.38855,
    fill: "#FAF7F3",
    stroke: "#BA8227",
    strokeWidth: 0.739325
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 561.695,
    y: 233.55,
    width: 11.798,
    height: 5.2786,
    rx: 2.6393,
    fill: "#FAF7F3",
    stroke: "#BA8227",
    strokeWidth: 0.739325
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 561.695,
    y: 239.568,
    width: 11.798,
    height: 4.77711,
    rx: 2.38855,
    fill: "#FAF7F3",
    stroke: "#BA8227",
    strokeWidth: 0.739325
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M620.795 282.149H590.467L561.045 556H620.795V282.149Z",
    fill: "url(#paint17_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.795 282.149H590.467L561.045 556H620.795V282.149Z",
    stroke: "white",
    strokeWidth: 1.98606
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_b_2100_37058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M629.484 282.183L659.741 280.72L702.328 552.967L642.718 555.85L629.484 282.183Z",
    fill: "url(#paint18_linear_2100_37058)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.484 282.183L659.741 280.72L702.328 552.967L642.718 555.85L629.484 282.183Z",
    stroke: "white",
    strokeWidth: 1.98606
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M664.8 299.026V299.026C666.191 298.846 667.453 299.856 667.582 301.253L667.782 303.428",
    stroke: "#BA8227",
    strokeWidth: 0.734842
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 656.627,
    y: 307.128,
    width: 14.2935,
    height: 5.87761,
    rx: 2.93881,
    transform: "rotate(-16.8239 656.627 307.128)",
    stroke: "#BA8227",
    strokeWidth: 0.734841
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 657.013,
    y: 313.392,
    width: 14.2935,
    height: 5.87761,
    rx: 2.93881,
    transform: "rotate(-16.8239 657.013 313.392)",
    stroke: "#BA8227",
    strokeWidth: 0.734841
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 658.706,
    y: 319.345,
    width: 14.2935,
    height: 5.87761,
    rx: 2.93881,
    transform: "rotate(-16.8239 658.706 319.345)",
    stroke: "#BA8227",
    strokeWidth: 0.734841
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2100_37058",
    x: 711.995,
    y: -151.766,
    width: 233.907,
    height: 277.459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.3104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2100_37058",
    x: 707.777,
    y: 48.8316,
    width: 356.042,
    height: 299.777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.3104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_2100_37058",
    x: 711.671,
    y: 278.424,
    width: 296.185,
    height: 423.373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.3104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_2100_37058",
    x: 518.937,
    y: 535.861,
    width: 338.859,
    height: 258.399,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.98134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_2100_37058",
    x: 268.791,
    y: 503.954,
    width: 304.367,
    height: 329.345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.3104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_2100_37058",
    x: 124.338,
    y: -250.27,
    width: 483.166,
    height: 509.047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.3104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_2100_37058",
    x: -28.5552,
    y: -84.2214,
    width: 250.597,
    height: 476.318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.3104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_2100_37058",
    x: 43.1197,
    y: 357.634,
    width: 210.842,
    height: 358.382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.89804
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_b_2100_37058",
    x: 937.92,
    y: 231.649,
    width: 227.965,
    height: 393.938,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.89804
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_2100_37058",
    x: 389.377,
    y: 163.904,
    width: 97.1787,
    height: 97.1785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.3104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_2100_37058",
    x: 427.354,
    y: 106.621,
    width: 87.1177,
    height: 96.5497,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.07423
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_2100_37058",
    x: 331.6,
    y: 210.061,
    width: 209.441,
    height: 111.746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.3104
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_2100_37058",
    x: 381.075,
    y: 287.884,
    width: 110.404,
    height: 273.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.98134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_b_2100_37058",
    x: 569.155,
    y: 201.824,
    width: 104.895,
    height: 84.3041,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.56757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_2100_37058",
    x: 611.547,
    y: 130.167,
    width: 69.9467,
    height: 69.9465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11.8443
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_b_2100_37058",
    x: 596.899,
    y: 157.012,
    width: 56.0891,
    height: 56.0892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.56757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_b_2100_37058",
    x: 594.726,
    y: 130.606,
    width: 83.9856,
    height: 69.5178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.56757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_b_2100_37058",
    x: 525.691,
    y: 246.908,
    width: 130.345,
    height: 344.334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 17.1244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_b_2100_37058",
    x: 594.196,
    y: 245.436,
    width: 143.533,
    height: 345.703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 17.1244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2100_37058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2100_37058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2100_37058",
    x1: 746.039,
    y1: -122.315,
    x2: 924.297,
    y2: 67.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#8DF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#9BCFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2100_37058",
    x1: 745.026,
    y1: 78.2823,
    x2: 920.027,
    y2: 365.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#FFD9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#FCFF82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2100_37058",
    x1: 747.35,
    y1: 307.875,
    x2: 1042.11,
    y2: 562.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#8DF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#9BCFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2100_37058",
    x1: 593.18,
    y1: 622.218,
    x2: 848.984,
    y2: 749.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539958,
    stopColor: "#FFDCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2100_37058",
    x1: 304.684,
    y1: 533.405,
    x2: 521.853,
    y2: 795.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#8DFFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#FFDD9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2100_37058",
    x1: 348.095,
    y1: -328.162,
    x2: 546.581,
    y2: 132.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#8DF8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#9BCFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2100_37058",
    x1: 5.92665,
    y1: -54.7701,
    x2: 309.334,
    y2: 130.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#FFD9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#FCFF82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2100_37058",
    x1: 189.308,
    y1: 405.963,
    x2: 19.4407,
    y2: 638.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D9FFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281306,
    stopColor: "#B4ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#FFF9C8",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#D6F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F9D988"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2100_37058",
    x1: 1096.79,
    y1: 283.082,
    x2: 907.304,
    y2: 539.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D9FFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281306,
    stopColor: "#B4ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#FFF9C8",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#D6F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F9D988"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2100_37058",
    x1: 419.833,
    y1: 193.354,
    x2: 449.887,
    y2: 233.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#FFD9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#FCFF82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2100_37058",
    x1: 490.133,
    y1: 176.052,
    x2: 435.406,
    y2: 153.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D9FFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281306,
    stopColor: "#B4ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#FFF9C8",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#D6F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F9D988"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2100_37058",
    x1: 365.002,
    y1: 239.512,
    x2: 386.323,
    y2: 320.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#8DFFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#FFDD9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2100_37058",
    x1: 397.099,
    y1: 376.287,
    x2: 483.494,
    y2: 380.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408231,
    stopColor: "#ADEAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BFFE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2100_37058",
    x1: 586.029,
    y1: 231.283,
    x2: 662.928,
    y2: 242.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408231,
    stopColor: "#ADEAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BFFE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2100_37058",
    x1: 651.707,
    y1: 156.237,
    x2: 643.477,
    y2: 177.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D9FFF",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281306,
    stopColor: "#B4ADFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#FFF9C8",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#D6F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#F9D988"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2100_37058",
    x1: 613.287,
    y1: 178.086,
    x2: 647.561,
    y2: 190.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFDC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539958,
    stopColor: "#FFDCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB9B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2100_37058",
    x1: 616.608,
    y1: 155.87,
    x2: 671.648,
    y2: 181.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCE4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2100_37058",
    x1: 562.614,
    y1: 282.149,
    x2: 682.354,
    y2: 316.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#FFD9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#FCFF82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2100_37058",
    x1: 687.53,
    y1: 279.376,
    x2: 569.71,
    y2: 319.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.693532
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388975,
    stopColor: "#FFD9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994177,
    stopColor: "#FCFF82"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2100_37058"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1062.21,
    height: 556,
    fill: "white",
    transform: "translate(0.895508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonnationHistoryBanner);
export default __webpack_public_path__ + "static/media/donnation-history-banner.f0c1a62158b2ce627c30551596931192.svg";
export { ForwardRef as ReactComponent };